import { Link } from "react-router-dom";
import { CITIES } from "../lib/cities";

export const SiteFooter = () => (
  <footer className="bg-[#0d2f4d] text-white" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
      <div>
        <p className="font-heading font-extrabold text-lg">THE DITCH <span className="text-[#C1CC24]">Careers</span></p>
        <p className="text-sm text-white/60 mt-3 max-w-xs leading-relaxed">
          Australian recruiters, situated in every major city. We find, vet and place
          the right people into the right roles — nationwide.
        </p>
        <p className="text-xs mt-4 font-medium tracking-wide flex flex-wrap gap-x-1.5 gap-y-1" data-testid="footer-cities">
          {CITIES.map((c, i) => (
            <span key={c.slug}>
              <Link to={`/recruiting/${c.slug}`} className="text-[#C1CC24]/80 hover:text-[#C1CC24] hover:underline underline-offset-2 transition-colors">{c.name}</Link>
              {i < CITIES.length - 1 && <span className="text-white/30"> ·</span>}
            </span>
          ))}
        </p>
      </div>
      <div className="text-sm space-y-2">
        <p className="text-xs uppercase tracking-[0.2em] text-white/40 mb-3">Explore</p>
        <Link to="/candidates" className="block text-white/70 hover:text-white transition-colors">For Candidates</Link>
        <Link to="/employers" className="block text-white/70 hover:text-white transition-colors">For Employers</Link>
        <Link to="/signin" className="block text-white/70 hover:text-white transition-colors">Sign in</Link>
      </div>
      <div className="text-sm space-y-2">
        <p className="text-xs uppercase tracking-[0.2em] text-white/40 mb-3">Get started</p>
        <Link to="/candidates" className="block text-white/70 hover:text-white transition-colors">I'm a Candidate</Link>
        <Link to="/employers" className="block text-white/70 hover:text-white transition-colors">I'm an Employer</Link>
        <a href="mailto:hello@theditchcareers.com.au" data-testid="footer-contact-email" className="block text-[#C1CC24] hover:text-white transition-colors mt-3">hello@theditchcareers.com.au</a>
      </div>
    </div>
    <div className="border-t border-white/10 py-5 text-center text-xs text-white/40">
      © {new Date().getFullYear()} The Ditch Careers · Australian recruiters · theditchcareers.com.au
    </div>
  </footer>
);
